import { REHYDRATE } from "redux-persist";

export const appRehydratedPredicate = (action) => {
	return action.type === REHYDRATE;
};
